import { KoncentroBaseModel } from './koncentro-base.model';

export class CustomerResearchDto {
  public name?: string;
  public surname?: string;
  public birthday?: string;
  public group_number?: number;
}

export class CustomerRecoveryDto {
  public id: number;
  public customerCode: string;
}

export class CustomerFileUpload {
  public exist: boolean;
  public originalFileName: string;
  public storageFileName: string;
  public date: string;
}
export class mgCustomer {
  public customerId: number;
  public puntoVendita: string;
  public puntoVenditaPref: string;
  public channel: string;
  public cardNo: string;
  public nome: string;
  public cognome: string;
  public fiscalCode: string;
  public birthDate: any;
  public sex: string;
  public mobile: string;
  public email: string;
  public toponym: string;
  public address: string;
  public addressNumber: string;
  public comune: string;
  public zipCode: string;
  public province: number;
  public flgAuth1: any;
  public flgAuth2: any;
  public flgAuth3: any;
  public flgAuthPush: any;
  public checkFiscalDataExistence: boolean;
}

export class mgCustomerDto {
  public customerId: number;
  public sourceCode: string;
  public preferredStoreId: number;
  public cardNo: string;
  public surname: string;
  public name: string;
  public fiscalCode: string;
  public birthDate: any;
  public sex: string;
  public mobile: string;
  public email: string;
  public toponymId: number;
  public address1: string;
  public addressNumber: string;
  public city: string;
  public zipCode: string;
  public provinceId: number;
  public privacyAuth: string;
  public privacyMktgActivity: string;
  public privacyMktgProfiling: string;
  public privacyPurchaseCom: string;
  public privacyTerminal: string;
  public privacyGenericComm: string;
  public privacyMktgResearch: string;
  public privacyOptin: string;
  public checkAccountExistence: boolean;
  public checkFiscalDataExistence: boolean;  
}

export class mgCustomerCompany {
  public customerId: number;
  public puntoVendita: string;
  public puntoVenditaPref: string;
  public channel: string;
  public cardNo: string;
  public flgType: string;
  public ragioneSociale: string;
  public partitaIva_codiceFiscale: string;
  public settore: string;
  public emailAziendale: string;
  public mobileAziendale: string;
  public cognome: string;
  public nome: string;
  public birthDate: any;
  public fiscalCode: string;
  public toponym: string;
  public address: string;
  public addressNumber: string;
  public comune: string;
  public zipCode: string;
  public province: number;
  public flgAuth1: any;
  public flgAuth2: any;
  public flgAuth3: any;
  public flgAuthPush: any;
  public checkFiscalDataExistence: boolean;
}

export class mgCustomerCompanyDto {
  public customerId: number;
  public sourceCode: string;
  public cardNo: string;
  public preferredStoreId: number;
  public companyData: Array<ContactDto>;
  public classificationsId: Array<number>;
  public surname: string;
  public name: string;
  public birthDate: any;
  public fiscalCode: string;
  public toponymId: number;
  public address1: string;
  public addressNumber: string;
  public city: string;
  public zipCode: string;
  public provinceId: number;
  public privacyAuth: string;
  public privacyMktgActivity: string;
  public privacyMktgProfiling: string;
  public privacyPurchaseCom: string;
  public privacyTerminal: string;
  public privacyGenericComm: string;
  public privacyMktgResearch: string;
  public privacyOptin: string;
  public checkAccountExistence: boolean;
  public checkFiscalDataExistence: boolean;
}

export class ContactDto {
  public id?: number;
  public flgType: string;
  public rowNum: number;
  public companyName: string;
  public fiscalCode: string;
  public vatCode: string;
  public email1: string;
  public mobile: string;
}

export class CustomerSummaryDto {
  public customerCode: number;
  public group_number: number;
  public name: string;
  public surname: string;
  public date_added: Date;
  public last_viewed: Date;
  public last_user_id: number;
  public last_user_name?: string;
  public division_id: number;
  public division_name?: string;
}

export class Customer {
  public companyId: number;
  public customerCode: number;
  public hostId: string;
  public name: string;
  public surname: string;
  public authorizations: string;
}

export class CustomerBasicInfo {
  public id?: string;
  public customerCode: string;
  public source_system: number;
  public preferred_store_id?: number;
  public name: string;
  public surname: string;
  public fiscal_code: string;
  public group_number: number;
  public address: string;
  public address_2: string;
  public address_number: string;
  public province_id: number;
  public toponym_id: number;
  public city: string;
  public zip_code: string;
  public country_id: number;
  public state_id: number;
  public phone_primary: string;
  public phone_mobile: string;
  public other_phone: string;
  public email_primary: string;
  public email_secondary: string;
  public employment_id: number;
  public flg_company: string;
  public flg_newsletter: any;
  public flag_register_name: any;
  public flag_general_communications: any;
  public flag_market_research: any;
  public flag_privacy: any;
  public flag_profiling: any;
  public flag_marketing_activities: any;
  public flag_purchase_communications: any;
  public flag_push_notifications: any;
  public birth_city: string;
  public birthday: any;

  public sex: string;
  public education: number;
  public occupation: number;
}

export class CustomerFamilyInfo {
  public civil_status_id: number;
  public relative_members: number;
  public children_number: number;

  public mate_birthday: any;
  public mate_name: string;
  public mate_surname: string;
  public mate_sex: string;
  public mate_birth_place: string;
  public mate_employment: number;
  public mate_education: number;

  public first_son_sex: string;
  public first_son_education: number;
  public first_son_employment: number;
  public first_son_birthday: any;

  public second_son_sex: string;
  public second_son_education: number;
  public second_son_employment: number;
  public second_son_birthday: any;

  public third_son_sex: string;
  public third_son_education: number;
  public third_son_employment: number;
  public third_son_birthday: any;

  public fourth_son_sex: string;
  public fourth_son_education: number;
  public fourth_son_employment: number;
  public fourth_son_birthday: any;

  public fifth_son_sex: string;
  public fifth_son_education: number;
  public fifth_son_employment: number;
  public fifth_son_birthday: any;
}

export class CustomerLoyaltyInfo {
  public id?: number;
  public customer_host_id: number;
  public parent_id: number;
  public division_id: number;
  public sales_network_id: number;
  public flag_fidelity: any;
  public flag_delegate: any;
  public welcome_date: any;
  public type_message_id: number;
  public flag_signature: any;
  public date_signature: any;
}

export class CustomerHobbyPetInfo {
  public flag_hobby_1: any;
  public flag_hobby_2: any;
  public flag_hobby_3: any;
  public flag_hobby_4: any;
  public flag_hobby_5: any;
  public flag_hobby_6: any;
  public flag_hobby_7: any;
  public flag_hobby_8: any;
  public flag_hobby_9: any;
  public flag_hobby_10: any;
  public flag_hobby_11: any;
  public flag_hobby_12: any;
  public pet_1: number;
  public pet_2: number;
  public pet_3: number;
  public pet_4: number;
  public other_pet_name: string;
  public other_pet: number;
}

export class CustomerCompanyData {

  public id?: string;
  public row_num: number;
  public flg_type: string;
  public company_name: string;
  public vat_code: string;
  public fiscal_code: string;
  public address: string;
  public address_number: string;
  public zip_code: string;
  public country_id: number;
  public province_id: number;
  public city: string;
  public phone_primary: string;
  public phone_mobile: string;
  public email_primary: string;
  public email_secondary: string;
  public other_telephone: string;
}

export class Education {
  public id?: number;
  public title: string;
  public description: string;
}

export class Employment {
  public id?: number;
  public name: string;
}

export class SourceSystem {
  public id?: number;
  public name: string;
  public description: string;
  public host_id: string;
}

export class CustomerListModel extends KoncentroBaseModel {
  dto ?= 'v2.CustomerListDto';
  id?: any;
  flg_company?: string;
  customerCode?: any;
  name?: string;
  sede?: string;
  vat_fiscal_code?: string;
  isCompany: boolean;
  denominazione?: string;
  surname?: string;
}

export class CustomerBaseTreeNode {

  public current: number;
  public previous: number;
  public percent: number;
  public name: string;
  public type: string;
  public children: CustomerBaseTreeNode[];
}

export class CustomerCard {
  customerCode: string;
  date_added: string;
  division_id: number;
  flg_company: string;
  company_name: string;
  vat_code: string;
  customer_id: number;
  card_id: number;
}

export class CustomerAuthModel {
  id: number;

  customer_id: number;
  account_type_id: string;
  account_type_description: string;
  account_type_host_id: string;

  user_account: string;
  customer_host_id: number;
  source_system_id: number;
  source_system_host_id: string;
  ts_user_account_update: Date;
  password_end_date: Date;
  ts_password_update: Date;
}

export class CustomerAuthListModel extends KoncentroBaseModel {
  dto ?= 'CustomerAuthListDto';
  id?: number;
  user_account: string;
  host_id: string;
  surname: string;
  name: string;
  card_no?: string;
  source_system_host_id?: string;
  account_type_host_id?: string;
}

export class CustomerAuthApiModel {
   userAccount: string;
   accountType: string;
   sourceCode: string;
   companyCode: string;
   notifyUser: boolean;
}

export class CustomerAuthApiResendModel {
  companyCode: string;
  sourceCode: string;
  accountId: string;
  accountType: string;
}

export class CustomerAuthHistoryModel {
  id: number;
  customer_auth_id: number;
  account_type_id: number;
  account_type_host_id: string;
  user_account: string;
  ts_del: Date;
  ts_ins: Date;
  ts_upd: Date;
  flg_state: string;

}

export class CustomerAuthTokenModel {
  id: number;
  customer_id: number;
  token: string;
  token_type: string;
  ts_expiry: Date;
  ts_del: Date;
  ts_ins: Date;
  ts_upd: Date;
  flg_state: string;

}

export class CustomerServicesInfo {
  public customerServiceId?: number;
  public serviceId: number;
  public customerId: number;
  public dateStart: string;
  public dateEnd: string;
  public flg_state: any;
  public flg_blklst: any;
  public dateBlklist: string;
  public reasonId: number;
  public serviceDescription: string;
}




// WEBPACK FOOTER //
// ./src/app/models/customer.model.ts